"use strict";import{ActionBar as a}from"./src/ActionBar.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-action-bar",a);
//# sourceMappingURL=sp-action-bar.js.map
